import { createSlice } from "@reduxjs/toolkit";
import { getCourseDetail } from "./courseDetailAction";

export const courseDetailSlice = createSlice({
  name: "courseDetail",
  initialState: {
    loading: false,
    data: {},
    message: "",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCourseDetail.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCourseDetail.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload.data;
      state.message = payload.message;
      state.error = null;
    });
    builder.addCase(getCourseDetail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "An error occurred";
    });
  },
});
